import React from 'react';
import { UrlService } from '../../core/services/UrlService';
import { SelfTestQuestion } from './model/SelfTestQuestion';

type Props = {
    id: string,
    q: SelfTestQuestion;
    onAnswerClicked: (answer?: string) => any;
}

const SelfTestTemplateDescriptionContext: React.FC<Props> = (props: Props) => {
    const handleClick = (ev: any) => {
        props.onAnswerClicked();
    }

    return (
        <div id={props.id} className={`self-test__test-heading q${props.id}`}>
            <div className="self-test__test-question-sizer">
                <div className="self-test__test-question-cover">
                    <img src={UrlService.getLocalImageUrl(props.q.image ?? "placeholder.png")} alt="" />
                </div>
                <div className="self-test__test-question-content">
                    <p className="title" dangerouslySetInnerHTML={{ __html: props.q.title }}></p>
                    <p className="content" dangerouslySetInnerHTML={{ __html: props.q.content }}></p>
                    <button className="self-test__button start-button primary" onClick={handleClick}>
                        { props.q.btnText ?? '開始評估'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SelfTestTemplateDescriptionContext;
